export const simpleMoneyMask: any = {
    mask: Number,
    min: 0,
    max: 999999999.99,
    scale: 2,
    signed: false,
    thousandsSeparator: ' ',
    radix: '.',
    mapToRadix: [','],
    autofix: true,
    padFractionalZeros: true,
    normalizeZeros: true
};

